import { Facebook, ExternalLink } from "lucide-react";
import { BRAND } from "../lib/brand";

/**
 * Embeds the Facebook Page Plugin (timeline feed) for the brand's page.
 * Uses the public Facebook plugin endpoint — no app key required.
 */
const FacebookFeed = () => {
  const pageUrl = BRAND.socials.facebook;
  const encodedHref = encodeURIComponent(pageUrl);
  const iframeSrc =
    `https://www.facebook.com/plugins/page.php?href=${encodedHref}` +
    `&tabs=timeline&width=500&height=640&small_header=false` +
    `&adapt_container_width=true&hide_cover=false&show_facepile=true`;

  return (
    <section
      data-testid="home-facebook-feed"
      className="max-w-7xl mx-auto px-6 lg:px-10 py-16"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-5 fade-up">
          <span className="inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-[0.3em] text-[#00b4ff] mb-3">
            <Facebook className="w-3.5 h-3.5" /> Live on Facebook
          </span>
          <h2 className="font-script text-5xl sm:text-6xl text-white leading-[1] mb-6">
            Follow our<br />latest drops.
          </h2>
          <p className="text-gray-300 leading-relaxed mb-6">
            New flavours, in-store specials, event reveals and behind-the-scenes — straight from
            our Facebook page. Tap any post to dive into the full thread.
          </p>
          <a
            href={pageUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="home-facebook-follow-link"
            className="neon-btn neon-btn--blue"
          >
            <Facebook className="w-4 h-4" /> Visit our page
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        <div className="lg:col-span-7 fade-up delay-2">
          <div
            data-testid="facebook-feed-frame"
            className="glass rounded-3xl border border-white/10 p-4 sm:p-5 overflow-hidden"
          >
            <div className="w-full overflow-hidden rounded-2xl">
              <iframe
                src={iframeSrc}
                title={`${BRAND.name} on Facebook`}
                width="500"
                height="640"
                style={{
                  border: "none",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  display: "block",
                  margin: "0 auto",
                }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacebookFeed;
